<template>
  <a name="newssss">
    <lazy-component @show.once="render(false)">
      <div ></div>
      <div v-if="isShow" >
        <Module ref="Module" class="newview"
        :title="'资讯'"
        :fetchCache="fetchCache"
        :fetchRequest="fetchRequest"
        :checkData="checkData"
        :showMore="showMore"
        :emptyTitle="'暂无资讯信息'"
        :moreEvent="clickMore">
          <div slot-scope="slotProps">
            <div v-for="(item, index) in slotProps.list"
            :key="index"
            @click="clickCell(item, index)"
            class="news">
              <p class="news-text">{{item.title}}</p>
              <div class="news-info">
                  <!--
                  <div class="news-tag-wrap" v-for="(tag, subIndex) in item.tags" :key="subIndex">
                   <span class="news-tag">{{tag}}</span>
                  </div> -->
                  <span class="news-source">{{item.source}}</span>
                  <span class="news-time">{{getTime(item)}}</span>
              </div>
            </div>
          </div>
        </Module>
      </div>
    </lazy-component>
  </a>
</template>

<script>
import Util from '@/base/Util';
import Module from '@/components/ModuleChoose.vue';
import StoreManger from '@/utils/FundHQJHManger';
// import Util from '@/base/Util';
import {
  detailPushPage,
} from '@/utils/nativeBridge';
// import dataModel from '@/model/news.model';

export default {
  name: 'FundNews',
  components: {
    Module,
  },
  data() {
    return {
      nativeData: {},
      fundCode: '',
      fundType: '',
      isShow: true,
      // pageData: [],
    };
  },
  computed: {},
  created() {
    // this.handleDefault();
  },
  mounted() {
    // console.log('✅mounted-fund-news');
  },
  methods: {
    show() {
      this.isShow = true;
      return this.isShow;
    },
    render(iscache) {
      if (this.show()) {
        this.nativeData = this.$store.state.native.fund;
        this.fundCode = this.nativeData.fundCode;
        this.fundType = this.nativeData.fundType;
        this.$nextTick(() => {
          if (iscache) {
            this.$refs.Module.cache();
          } else {
            this.$refs.Module.start();
          }
        });
      }
    },
    fetchCache() {
      return this.$store.state.news.fund[this.fundCode];
    },
    fetchRequest() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('updateNews', this.fundCode)
          .then((res) => {
            resolve(res);
          })
          .catch(() => {
            reject();
          });
      });
    },
    showMore(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 1);
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    handleDefault() {
      // this.pageData = dataModel.objectArrayWithKeyValuesArray([{}], [{}]);
    },
    getTime(item) {
      const res = Util.formatTimeString(item.time);
      return res;
    },
    clickCell(item, index) {
      detailPushPage({
        type: 1,
        url: `fund://page/newsdetail?type=0&newsid=${item.code}`,
      });
      this.reportMonitor({
        eventName: `pz.xx.news.${index}`,
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        appId: '7be9fe8d23404e658637288726244df5',
        url: '/pages/optionalNews',
        params: {
          fundCode: this.fundCode,
          fundName: name,
          index: 1,
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.news.more',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
  },
};
</script>

<style scoped lang="less">
.mdian{
   padding-top:50px;
   margin-top:-50px;
}
.newview{
  border-radius: 12px;
}
.news {
  background-color: #ffffff;
  margin-left: 24px;
  padding-top: 30px;
  padding-bottom: 30px;
  margin-right: 24px;
   &:nth-last-child(1) {
      &:after{
        display: none;
      }
    }
  &-text {
    font-family: PingFangSC-Regular;
    font-size: 32px;
    color: #000000;
    text-align: left;
    line-height: 1.7;
  }
  &-info {
    display: flex;
    align-items: center;
    margin-top: 16px;
  }
  &-tag-wrap {
    display: flex;
    margin-right: 10px;
  }
  &-tag {
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #52a2ff;
    line-height: 20px;
    padding: 4px 6px;
    border-radius: 4px;
    background-color: #edf5ff;
  }
  &-source {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999999;
    line-height: 28px;
    margin-right: 20px;
  }
  &-time {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999999;
    line-height: 28px;
  }
}
</style>
